import React from 'react';
import styled from 'styled-components';

import { ViewPracticalAssessmentVideoPreview } from '@/administration/pages/Course/pages/assessments/practicalAssessmentVideo/variants/View/ViewPracticalAssessmentVideoPreview';
import { Button } from '@/ui/Button';
import { UploadedFileVideo } from '@/component/FileUpload/types';
import { RUserLearningSubmissionType } from '@/store/v2';
import { useCreateUserLearningSubmission } from '@/features/course/learner/hooks/useCreateUserLearningSubmission';

type ViewPracticalAssessmentVideoReadyToSubmitProps = {
  videoLink?: string;
  uploadedVideo?: UploadedFileVideo;
  pageRemoteId?: number;
  learningId?: number;
  onSubmitted: () => void;
  onReplace: () => void;
};

const RootStyled = styled.div`
  display: flex;
  width: 100%;
  flex-direction: column;
  gap: 16px;
`;

const ContentStyled = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  border: 1px solid ${({ theme }) => theme.colors.neutral.outline1};
  border-radius: 8px;
  overflow: hidden;
`;

const ActionsStyled = styled.div`
  width: 100%;
  display: flex;
  justify-content: flex-end;
`;

const HeaderStyled = styled.div`
  display: flex;
  padding: 16px;
  justify-content: flex-end;
`;

export const ViewPracticalAssessmentVideoReadyToSubmit = ({
  videoLink,
  uploadedVideo,
  pageRemoteId,
  learningId,
  onSubmitted,
  onReplace,
}: ViewPracticalAssessmentVideoReadyToSubmitProps): JSX.Element => {
  const { createUserLearningSubmission, loading: submitInProgress } = useCreateUserLearningSubmission();

  const handleSubmit = async () => {
    const isVideoReady = Boolean(videoLink || uploadedVideo);

    if (pageRemoteId && learningId && isVideoReady) {
      if (videoLink) {
        await createUserLearningSubmission({
          pageId: pageRemoteId,
          learningId,
          submissionData: {
            videoLink: videoLink,
          },
          assessmentType: RUserLearningSubmissionType.PracticalAssessmentVideo,
        });
      } else if (uploadedVideo) {
        await createUserLearningSubmission({
          pageId: pageRemoteId,
          learningId,
          submissionData: {
            vimeoId: uploadedVideo.vimeoId,
            duration: uploadedVideo.duration,
            ratio: uploadedVideo.ratio,
            thumbnail: uploadedVideo.thumbnail,
          },
          assessmentType: RUserLearningSubmissionType.PracticalAssessmentVideo,
        });
      }

      onSubmitted();
    }
  };

  return (
    <>
      <RootStyled>
        <ContentStyled>
          <HeaderStyled>
            <Button variant="ghost" icon={['fas', 'repeat']} onClick={onReplace}>
              Replace
            </Button>
          </HeaderStyled>
          <ViewPracticalAssessmentVideoPreview videoLink={videoLink} uploadedFileVideo={uploadedVideo} />
        </ContentStyled>
        <ActionsStyled>
          <Button variant="primary" onClick={handleSubmit} $loading={submitInProgress}>
            Submit
          </Button>
        </ActionsStyled>
      </RootStyled>
    </>
  );
};
